<template>
  <div>
    <h2 class="mobile-page-title">Add/View Photos/Drawings/Files</h2>
    <form class='md-layout file-upload-form' @submit='submit($event)'>
    <md-field>
      <label>Upload A File</label>
      <md-file @change="cool($event.target.files)" v-model="fileU"></md-file>
    </md-field>
    <md-field class="md-has-file">
      <label>Description for File</label>
      <md-icon>description</md-icon>
      <md-input v-model='description' />
    </md-field>
    <md-button type='submit' class="md-success md-sm">Upload</md-button>
    </form>
    <div class="gpr-info files" v-for="file in files" :key="file.id">
      <div class="file-info">
        <h6><a :href="file.url">{{file.fileName}}</a></h6>
        <p>Posted By: {{file.userName}}</p>
        <p>Description: {{file.description}}</p>
        <p>Added at: {{file.createdAt | formatDate}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api';
  import moment from 'moment';
  import axios from 'axios';
  import { AzureNamedKeyCredential } from '@azure/data-tables';
  import { BlobServiceClient } from '@azure/storage-blob';

  export default {
    props: {
      project: {
        type: Object
      }
    },
    data() {
      return {
        files: [],
        description: '',
	      newFile: null,
        fileU: ''
      }
    },
    methods: {
      cool(files) {
	       this.newFile = files;
         console.log(this.newFile)
      },
      submit(e) {
	      e.preventDefault();

        var formData = new FormData();
        console.log('here')
        console.log(this.newFile)
        formData.append('file', this.newFile[0]);
        formData.append('description', this.description);
        console.log(this.project)
        console.log(this.project.project.id)
        api.uploadFileToProject(this.project.project.id, formData)
          .then(a => {
            console.log('file has uploaded')
            console.log(a)
            this.files = [...this.files, a.data];
            this.newFile = null;
            this.description = '';
            this.fileU = '';
          })
      },
      async downloadFile(blobName) {
        const accountName = 'safecoredev';
        const accountKey = 'lEKLCPgrzlYQHPebGRCEzLo+axJzHEkAg+Qgyr9ova/aI+z3SwLaitCgkQCK97H0Ym/mRQTPG/DA7ezPgF/rBA==';
        const blobEndpoint = `https://${accountName}.blob.core.windows.net`;
        const containerName = 'dev'

        const credential = new AzureNamedKeyCredential(accountName, accountKey);
        const blobServiceClient = new BlobServiceClient(blobEndpoint, credential);

        const containerClient = blobServiceClient.getContainerClient(containerName);
        const blobClient = containerClient.getBlobClient(blobName);

        const downloadResponse = await blobClient.download();
        const blobContent = await downloadResponse.blobBody;

        const url = window.URL.createObjectURL(blobContent);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', blobName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
    },
    created() {
      api.getProjectFiles(this.project.project.id)
        .then(a => {
          console.log(a.data)
          this.files = a.data.filter(a => a)
        })
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('MM/DD/YYYY')
        }
      }
    }
  }
</script>
<style lang="scss">

</style>
